import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const HeadingSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default HeadingSVG;
